export const SITUACAO_INATIVA = "INATIVA";

export const INATIVAR_TEXTOS = {
  titulo: "Inativar distribuição",
  subtitulo: "Essa ação tira a distribuição da escolha dos novos escopos.",
  intro: "Você vai inativar esta distribuição por coletor:",
  tituloEfeitos: "O que acontece ao inativar",
};

export const EFEITOS_INATIVAR = [
  "Ela deixa de aparecer na escolha de distribuição dos novos escopos macro.",
  "Os escopos que já a usam continuam com ela, sem recalcular a distribuição por coletor.",
  'Nada é excluído: para usar de novo, marque "Mostrar inativas" e ative.',
];

/** Ativar não abre modal (Figma de 01/11, 2.8): o toast sai direto da linha. */
export const ATIVAR_ERRO = "Não foi possível ativar a distribuição.";

export const DEMAIS_ZERO = "(demais 0%)";
export const FIXO = "(fixo)";
export const SEPARADOR = "  ·  ";
